<section
  *ngIf="activeBanner as event"
  class="homepage-event-banner site-content-container"
  aria-labelledby="homepage-event-banner-title"
>
  <div class="homepage-event-banner__card">
    <div class="homepage-event-banner__layout">
      <div class="homepage-event-banner__media">
        <app-banner-image
          [src]="event.imageUrl"
          [alt]="event.imageAlt"
          [framing]="event.imageFraming"
        ></app-banner-image>
        <button
          *ngIf="showFramingAction"
          type="button"
          class="homepage-event-banner__framing-action"
          (click)="adjustFraming.emit()"
        >
          <app-icon name="crop" aria-hidden="true"></app-icon>
          Adjust framing
        </button>
      </div>
      <div class="homepage-event-banner__content">
        <span
          class="homepage-event-banner__badge"
          [class.homepage-event-banner__badge--live]="event.status === 'LIVE'"
        >
          {{ event.status === 'LIVE' ? 'Live Now' : 'Upcoming Live Event' }}
        </span>
        <h2
          id="homepage-event-banner-title"
          class="homepage-event-banner__title"
        >
          {{ event.title }}
        </h2>
        <p class="homepage-event-banner__meta">
          <app-icon
            name="calendar-days"
            class="cx-icon--sm"
            aria-hidden="true"
          ></app-icon>
          <span>{{ formatEventTime(event) }} · {{ event.timezoneLabel }}</span>
        </p>
        <p class="homepage-event-banner__description">
          {{ event.description }}
        </p>
        <p class="homepage-event-banner__supporting-text">
          RSVP to join this community conversation.
        </p>
        <div class="homepage-event-banner__actions">
          <a
            data-testid="homepage-banner-event-link"
            class="btn homepage-event-banner__action homepage-event-banner__action--primary"
            [routerLink]="eventPath"
          >
            <app-icon
              name="calendar-days"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon>
            View event &amp; RSVP
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
